export const formatGeometryFilter = (condition: Record<string, string>, geometryFilter = false) => ({
  geometry: { value: geometryFilter ? JSON.stringify(condition) : undefined, min: null, max: null },
});
